import styled from "styled-components";

export const StyledPolicyPage = styled.div`
    margin-bottom: 30px;

    h1 {
        font-size: var(--size-32);
        font-style: normal;
        font-weight: bold;
        line-height: 53px;
        color: var(--color-primary);
    }

    p {
        font-size: var(--size-16);
        font-style: normal;
        font-weight: normal;
        line-height: 24px;
        color: var(--color-grey-900);
    }

    h3 {
        font-size: var(--size-18);
        line-height: 24px;
        color: var(--color-primary);
    }

    h2 {
        font-size: var(--size-16);
        line-height: 22px;
        color: var(--color-primary);
    }

    table {
        font-size: var(--size-14);
        color: var(--color-grey-900);
        text-align: left;
        border-collapse: collapse;
        border: 1px solid var(--color-grey-800);

        td {
            padding: 10px;
            border: 1px solid var(--color-grey-800);
        }

        th {
            padding: 10px;
            border: 1px solid var(--color-grey-800);
        }
    }
`;
